import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, BookOpen, Star } from 'lucide-react';
import { CTAButton } from './Shared';
export const Hero = () => {
  return <div className="relative overflow-hidden pt-12 pb-8 md:pt-20 md:pb-12 bg-transparent" data-id="element-116">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-pink/20 rounded-full blur-[140px] -z-10 pointer-events-none" data-id="element-117"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-[0px] space-x-[4px] bg-transparent" data-id="element-119">
          <div className="inline-flex bg-white border border-brand-pink/50 px-4 py-1.5 rounded-full mb-4 space-x-2 pt-[0px] pb-[0px] pl-[1px] pr-[1px] flex-row items-center justify-center shadow-sm" data-id="element-120">
            <span className="text-[12px]" data-id="element-121">🦶</span>
            <span className="font-serif font-semibold tracking-wider md:text-base text-[12px] text-brand-text" data-id="element-122">
              LUMEN AKASHA™
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-serif font-bold mb-8 text-[18px]" data-id="element-123">
            Todo tu sistema de gestión clínica.
            <br data-id="element-124" />
            <span className="rose-gradient-text text-[24px]" data-id="element-125">
              Listo. Desde hoy.
            </span>
          </h1>

          <div className="mb-8 relative z-10" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/wyjG84NgdP4uZgHuWM8w6D/mockup_landing1.png" alt="REFLEXO-PRO Manual de Práctica Clínica" className="w-full max-w-3xl mx-auto drop-shadow-[0_20px_50px_rgba(212,115,140,0.25)] pl-[60px] pr-[60px]" data-id="element-127" />
          </div>

          <div className="max-w-3xl mx-auto mb-8 space-y-3 px-4" data-id="element-128">
            <p className="md:text-xl font-bold text-brand-rose font-[Georgia,_serif] text-[12px]" data-id="element-129">
              El sistema N°1 para terapeutas en reflexología en Argentina
            </p>
            <p className="md:text-base text-brand-text/80 text-[12px] font-[Inter,_sans-serif]" data-id="element-130">
              Fichas clínicas + planillas de sesión + control de gabinete listos
              para usar. Sin buscar. Sin improvisar. Sin perder pacientes por el
              desorden.
            </p>
          </div>

          <div className="flex flex-wrap md:gap-6 mb-12 text-xs md:text-sm font-medium gap-[12px] items-start justify-center" data-id="element-131">
            <div className="flex bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pt-[6px] pb-[6px] pl-[10px] pr-[10px] mt-[0px] ml-[0px] items-start justify-start shadow-sm" data-id="element-132">
              <FileText className="w-4 h-4 mr-2 text-brand-rose shrink-0" data-id="element-133" />
              100% PDF
            </div>
            <div className="flex items-center bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pl-[10px] pr-[10px] ml-[0px] shadow-sm" data-id="element-134">
              <Zap className="w-4 h-4 mr-2 text-brand-rose shrink-0" data-id="element-135" />
              Acceso en 5 min
            </div>
            <div className="flex items-center bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pb-[9px] mb-[10px] shadow-sm" data-id="element-136">
              <span className="mr-2 text-brand-rose shrink-0" data-id="element-137">🇦🇷</span>
              Hecho para Argentina
            </div>
            <div className="flex items-center bg-white px-4 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap text-[9px] pb-[9px] mb-[10px] shadow-sm" data-id="element-138">
              <span className="mr-2 text-brand-rose shrink-0" data-id="element-139">🦶</span>
              Todos los niveles de práctica
            </div>
          </div>

          <div className="flex flex-col items-center space-y-6" data-id="element-140">
            <CTAButton className="text-xl px-10 py-5" data-id="element-141">
              🦶 → QUIERO MI KIT REFLEXO-PRO AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-muted" data-id="element-142">
              <div className="flex items-center text-[10px]" data-id="element-143">
                <Shield className="w-4 h-4 mr-1.5" data-id="element-144" /> Garantía 7 días
              </div>
              <div className="flex items-center text-[10px]" data-id="element-145">
                <Lock className="w-4 h-4 mr-1.5" data-id="element-146" /> Pago seguro
              </div>
              <div className="flex items-center text-[10px]" data-id="element-147">
                <CreditCard className="w-4 h-4 mr-1.5" data-id="element-148" /> Mercado Pago
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Social Proof Bar */}
      <div className="mt-12 border-y border-brand-pink/20 bg-white/50 py-4 pt-[1px] pb-[1px]" data-id="element-149">
        {/* Mobile: wrapped grid */}
        <div className="md:hidden flex flex-wrap justify-center gap-x-6 gap-y-2 px-4 text-[13px]" data-id="element-150">
          <div className="flex items-center" data-id="element-151">
            <span className="font-bold text-brand-rose mr-1.5" data-id="element-152">+200</span>
            terapeutas organizados
          </div>
          <div className="flex items-center" data-id="element-153">
            <span className="font-bold text-brand-rose mr-1.5" data-id="element-154">1</span>
            Tomo listo
          </div>
          <div className="flex items-center" data-id="element-155">
            <span className="font-bold text-brand-rose mr-1.5" data-id="element-156">2</span> Bonos
            incluidos
          </div>
          <div className="flex items-center" data-id="element-157">
            <Star className="w-3.5 h-3.5 text-brand-rose fill-brand-rose mr-1" data-id="element-158" />
            4.9/5 calificación
          </div>
        </div>

        {/* Desktop: horizontal row with dots */}
        <div className="hidden md:flex flex-row items-center space-x-6 justify-center whitespace-nowrap px-4" data-id="element-159">
          <div className="flex items-center text-[15px]" data-id="element-160">
            <span className="font-bold text-brand-rose mr-2" data-id="element-161">+200</span>
            terapeutas organizados
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-rose/30 shrink-0" data-id="element-162"></div>
          <div className="flex items-center text-[15px]" data-id="element-163">
            <span className="font-bold text-brand-rose mr-2" data-id="element-164">3</span> Tomos
            listos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-rose/30 shrink-0" data-id="element-165"></div>
          <div className="flex items-center text-[15px]" data-id="element-166">
            <span className="font-bold text-brand-rose mr-2" data-id="element-167">2</span> Bonos
            incluidos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-rose/30 shrink-0" data-id="element-168"></div>
          <div className="flex items-center text-[15px]" data-id="element-169">
            <Star className="w-4 h-4 text-brand-rose fill-brand-rose mr-1" data-id="element-170" />
            4.9/5 calificación
          </div>
        </div>
      </div>
    </div>;
};